import React from 'react';
import { useAppSelector } from 'hooks';

import { Currency } from '~components/form-fields/inputs';

import { ServiceTotal } from '~support-at-home/models';

import { selectAppointmentServiceTypes } from '~appointments/selectors/serviceTypes';

interface ComponentProps {
  category_id: string;
  section?: any;
}

const BudgetSectionTotal: React.FC<ComponentProps> = ({ category_id, section }) => {
  const serviceTypes = useAppSelector(selectAppointmentServiceTypes);
  const { service_totals, totals } = section || {};

  const getServiceName = (service_type_id: string): string => {
    const service = serviceTypes.find(({ id }) => id === Number(service_type_id));
    return service ? service.name : service_type_id;
  };

  const buildRow = (serviceTotal: ServiceTotal, index: number) => {
    const { service_type_id, contribution, govSubsidy, total } = serviceTotal;
    return (
      <div key={`row-${category_id}-${index}`} id={`row-${category_id}-${index}`} className="row mb-2 px-1">
        <div className="service-column">{getServiceName(service_type_id)}</div>
        <div className="contrib-column">
          <Currency
            id={`service-${service_type_id}-contribution`}
            name={`service-${service_type_id}-contribution`}
            type="currency"
            value={contribution}
            disabled
            noDecimals
          />
        </div>
        <div className="government-column">
          <Currency
            id={`service-${service_type_id}-govSubsidy`}
            name={`service-${service_type_id}-govSubsidy`}
            type="currency"
            value={govSubsidy}
            disabled
            noDecimals
          />
        </div>
        <div className="total-column">
          <Currency
            id={`service-${service_type_id}-total`}
            name={`service-${service_type_id}-total`}
            type="currency"
            value={total}
            disabled
            noDecimals
          />
        </div>
      </div>
    );
  };

  const { cost, contribution, govSubsidy } = totals || {};

  return (
    <>
      {/* Header row */}
      <div className="row fw-bold mb-2 border-bottom pb-2 px-1">
        <div className="service-column">Service</div>
        <div className="contrib-column">Co-Contribution</div>
        <div className="government-column">Gov. Contribution</div>
        <div className="total-column">Total</div>
      </div>

      {service_totals &&
        service_totals.map((serviceTotal: ServiceTotal, index: number) => buildRow(serviceTotal, index))}

      <div className="row fw-bold border-top pt-2 px-1">
        <div className="service-column" />
        <div className="contrib-column">
          <Currency
            id={`${category_id}-totalContribution`}
            name={`${category_id}-totalContribution`}
            type="currency"
            value={contribution}
            disabled
            noDecimals
          />
        </div>
        <div className="government-column">
          <Currency
            id={`${category_id}-totalGovSubsidy`}
            name={`${category_id}-totalGovSubsidy`}
            type="currency"
            value={govSubsidy}
            disabled
            noDecimals
          />
        </div>
        <div className="total-column">
          <Currency
            id={`${category_id}-totalCost`}
            name={`${category_id}-totalCost`}
            type="currency"
            value={cost}
            disabled
            noDecimals
          />
        </div>
      </div>
    </>
  );
};

export default BudgetSectionTotal;
